(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-article-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-article-sticky')) {
    customElements.define(
      'cs-article-sticky',
      class extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('.cs-asticky__bar');
          this.end = document.querySelector('.cs-acta');
          this.onScroll = () => {
            const past = window.scrollY > window.innerHeight * 0.8;
            const atEnd = this.end ? this.end.getBoundingClientRect().top < window.innerHeight : false;
            const show = past && !atEnd;
            this.bar.dataset.visible = String(show);
            this.bar.toggleAttribute('inert', !show);
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }
        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-home-inside"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__csIngModal) return;
    window.__csIngModal = true;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let trigger = null;

    const close = (dialog) => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      const done = () => {
        dialog.classList.remove('is-closing');
        dialog.close();
      };
      if (reduce.matches) return done();
      dialog.classList.add('is-closing');
      const t = setTimeout(done, 300);
      dialog.addEventListener('animationend', () => { clearTimeout(t); done(); }, { once: true });
    };

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cs-ing-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.csIngOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        trigger = opener;
        dialog.showModal();
        document.documentElement.classList.add('cs-ing-lock');
        dialog.querySelector('[data-cs-ing-close]')?.focus();
        return;
      }
      const closer = e.target.closest('[data-cs-ing-close]');
      if (closer) return close(closer.closest('dialog'));
      // Click on the backdrop: the target is the dialog element itself.
      if (e.target instanceof HTMLDialogElement && e.target.classList.contains('cs-ing-modal')) close(e.target);
    });

    // Escape: animate the close instead of the native instant close.
    document.addEventListener('cancel', (e) => {
      if (!e.target.classList?.contains('cs-ing-modal')) return;
      e.preventDefault();
      close(e.target);
    }, true);

    document.addEventListener('close', (e) => {
      if (!e.target.classList?.contains('cs-ing-modal')) return;
      document.documentElement.classList.remove('cs-ing-lock');
      if (trigger) { trigger.focus(); trigger = null; }
    }, true);

    // Focus trap (showModal already makes the page inert; this keeps Tab cycling inside the panel).
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const dialog = document.querySelector('dialog.cs-ing-modal[open]');
      if (!dialog) return;
      const items = [...dialog.querySelectorAll('button, summary, a[href], [tabindex]:not([tabindex="-1"])')]
        .filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
